import { useLocation, useNavigate } from "react-router-dom";
import styled from 'styled-components';

const Container = styled.div`
  position: ${props => props.$isMobileView ? 'inherit' : 'fixed' };
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  width: 240px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  background: #ffffff;
  border-right: ${props => props.$isMobileView ? 'none' : '1px solid #C2C9D1' };
  margin-top: ${props => props.$isMobileView ? '0px' : '39px' };
`

export default ({
  isMobileView,
  setIsDrawerOpen,
  appRootPath
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  
  const itemStyle = {
    color: '#565656',
    padding: '7px 15px',
    cursor: 'pointer',
    borderRadius: '10px',
    fontSize: '14px'
  }

  const selectedStyle = {
    background: '#f3fbff',
    color: '#0280c6',
  }

  const onItemClicked = (name) => {
    if (setIsDrawerOpen) {
      setIsDrawerOpen(false)
    }
    if (pathname !== `/${name}`) {
      navigate(`${appRootPath}${name}`);
    }
  }

  const Tab = ({ name, path }) => {
    let extraStyle;
    if (pathname === appRootPath) {
      extraStyle = (path === '' ? selectedStyle : {});
    } else {
      extraStyle = (pathname?.includes(path) ? selectedStyle : {});
    }
    return (
      <div
        style={{
          ...itemStyle,
          ...extraStyle
        }}
        onClick={() => onItemClicked(path)}
      >
        {name}
      </div>
    )
  }

  return (
    <Container $isMobileView={isMobileView}>
      <Tab name='Home' path='' />
    </Container>
  )
}